import React from 'react';
import Img from "../../images/services/cn/custom.png";
import {Container, Row, Col} from "react-bootstrap";
import {LazyLoadImage} from "react-lazy-load-image-component";

function Buildpurpose(props) {
    return (
        <div className="services_orange_bg p-100">
            <Container>
                <Row>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto text-center order-2 order-md-1">
                        <LazyLoadImage
                            src={Img}
                            effect="blur" alt="Image" className="img-fluid"
                        />
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="services_title my-auto order-1 order-md-2">
                        <h2>Build And Run Scalable Applications With Our Expert Cloud Native Services</h2>
                        <p>Fundamental organizational transformation requires a strong strategic sense of developing and
                            deploying microservices. While you migrate to the cloud, let TekRevol help you reengineer
                            the business processes for maximum adaptability of cloud platforms.</p>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Buildpurpose;